import { Text, styled, designTokens } from '@volkswagen-onehub/components-core';

export const HeaderTextWrapper = styled.div`
  display: grid;
  gap: 8px;
  align-self: end;
  flex-grow: 1;
`;

export const StyledHeaderText = styled(Text)(
  ({ theme }) => `
  color: ${theme.colors.content.primary};
  word-break: normal;
  overflow-wrap: anywhere;
`);

export const StyledSubtitleText = styled(Text)(
  ({ theme }) => `
  color: ${theme.colors.content.tertiary};
  word-break: normal;
  overflow-wrap: anywhere;
`);
